export const PRO_APP_BASE_PATH = '/pro'

export const GOODSTACK_PRO_LOGIN_PATH = `${PRO_APP_BASE_PATH}/login`

export const isProAppPath = (path: string): boolean =>
  path === PRO_APP_BASE_PATH || path.startsWith(`${PRO_APP_BASE_PATH}/`)
